<template>
    <div class="assets_card" @click="jumpToDetail(item)">
        <!-- <div class="imgs_wrapper" @touchstart="mouseenterHandler" @touchmove="mousemoveHandler"
            @touchend="mouseleaveHandler" v-loading="loading"
            :style="{ backgroundImage: 'url(' + props.background + ')' || 'linear-gradient(180deg, rgba(235, 235, 235, 1) 0%, rgba(166, 166, 166, 1) 100%)' }">

            <div v-for="(item, index) in list" v-show="index == currentIndex || loading"
                :style="{ backgroundImage: 'url(' + item + ')' }">
            </div>
        </div> -->
        <img :src="list[0]" alt="" :style="{backgroundImage: 'url(' + (props.item.modelBgImage || 'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png') + ')'}">
        <h6>{{ item.name }}</h6>
        <div class="info">
            <span><van-icon :name="require('@/assets/imgs/icon5.png')" size="14" /> {{ item.browseCount || 0}}</span>
            <span><van-icon :name="require('@/assets/imgs/icon6.png')" size="14" /> {{ item.thumbsUpCount || 0}}</span>
            <span><van-icon :name="require('@/assets/imgs/icon27.png')" size="14" /> {{ item.liked || 0}}</span>
            <span><van-icon :name="require('@/assets/imgs/icon26.png')" size="14" /> 0</span>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { throttle } from 'lodash-es';
import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps({
    item: {
        type: Object,
        default: () => ({})
    }
})

const list = ref([]), currentIndex = ref(0), loading = ref(false)
onMounted(() => {
    list.value = props.item.picUrl.split(';')
})

function jumpToDetail(item) {
    router.push({ path: '/assets-detail', query: { id: item.id } })
    window.scrollTo(0, 0)
}

// var x = 0, _stepWidth = 0, completed = false
// const mouseenterHandler = e => {
//     console.log(e);
//     x = e.touches[0].clientX
//     _stepWidth = e.target.clientWidth / list.value.length / 2
//     if(list.value.length == 0 || completed) return
//     var completedNum = 1
//     list.value.map(url => {
//         var img = new Image();
//         img.onload = function () {
//             if(++completedNum >= list.value.length - 1){
//                 loading.value = false
//                 completed = true
//             }
//         }
//         img.onerror = function () {
//             if(++completedNum >= list.value.length - 1){
//                 loading.value = false
//                 completed = true
//             }
//         }
//         img.src = url
//     })
//     loading.value = true
// }

// const _mousemoveHandler = e => {
//     if (loading.value) return
//     if (e.touches[0].clientX - x >= _stepWidth) {
//         movePrev()
//         x = e.touches[0].clientX
//     }
//     if (e.touches[0].clientX - x <= -_stepWidth) {
//         moveNext()
//         x = e.touches[0].clientX
//     }
// }

// const mousemoveHandler = throttle(_mousemoveHandler, 50)

// const mouseleaveHandler = e => {
//     currentIndex.value = 0
// }

// function moveNext() {
//     if (currentIndex.value == list.value.length - 1) {
//         currentIndex.value = 0
//     } else {
//         currentIndex.value++
//     }
// }

// function movePrev() {
//     if (currentIndex.value == 0) {
//         currentIndex.value = list.value.length - 1
//     } else {
//         currentIndex.value--
//     }
// }
</script>

<style scoped lang="scss">
.assets_card {
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    margin-right: 18rem;
    position: relative;
    padding-bottom: 10rem;
    .imgs_wrapper {
        width: 100%;
        height: 150rem;
        position: relative;
        background-size: cover;

        div {
            width: 100%;
            height: 100%;
            background-size: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    >img{
        width: 100%;
        height: 150rem;
        object-fit: cover;
        background-size: cover;
    }
    h6{padding: 15rem 10rem;}
    .info{
        display: flex; align-items: center; justify-content: space-between; padding: 0 10rem 5rem 10rem; color: #999;
    }

    .author{
        padding: 0 10rem 5rem 10rem;
        img{
            width: 20rem; height: 20rem; margin-right: 10rem;
        }
    }
}
</style>
